import Vue from "vue";
import Vuex from "vuex";
import {
  getDefaultEmailRequest,
  setDefaultEmailRequest,
  getAllCustomersRequest,
  getAllEmployeesRequest,
  addEmployeeRequest,
  updateEmployeeRequest,
  deleteEmployeeRequest,
  postEmployeeToNotifyOnOrderRequest
} from "./requests/index";

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    token: "",
    orders: [],
    customers: [],
    employees: [],
    configs: {
      defaultEmail: ""
    }
  },
  mutations: {
    setDefaultEmail(state, payload) {
      state.configs.defaultEmail = payload;
    },
    setOrders(state, payload) {
      state.orders = payload;
    },
    addOrder(state, payload) {
      state.orders.push(payload);
    },
    setEmployees(state, payload) {
      state.employees = payload;
    },
    addEmployee(state, payload) {
      state.employees.push(payload);
    },
    deleteEmployee(state, payload) {
      let indexToBeDeleted = state.employees.findIndex(emp => emp._id === payload.employeeID);
      let tmp = state.employees;
      tmp.splice(indexToBeDeleted, 1);
      state.employees = [...tmp];
    },
    updateEmployee(state, payload) {
      let employeeIndex = state.employees.findIndex(emp => emp._id === payload._id);
      let oldEmployees = [...state.employees];
      oldEmployees.splice(employeeIndex, 1);
      state.employees = [{ ...state.employees[employeeIndex], ...payload.updates }, ...oldEmployees];
    },
    setCustomers(state, payload) {
      state.customers = payload;
    },
    updateCustomer(state, payload) {
      let customerIndex = state.customers.findIndex(customer => customer.email === payload.email);
      let oldCustomers = [...state.customers];
      oldCustomers.splice(employeeIndex, 1);
      state.customers = [{ ...state.customers[customerIndex], ...payload.updates }, ...oldCustomers];
    },
    setToken(state, payload) {
      state.token = payload;
    }
  },
  actions: {
    loadConfigs({ commit, state }) {
      return getDefaultEmailRequest(state.token).then(response => {
        commit("setDefaultEmail", response.data);
      });
    },
    setDefaultEmail({ commit, state }, payload) {
      return setDefaultEmailRequest(state.token, payload).then(response => {
        commit("setDefaultEmail", response.data);
      });
    },
    loadAllCustomers({ commit, state }) {
      return getAllCustomersRequest(state.token, 50).then(response => {
        commit("setCustomers", response.data);
      });
    },
    loadAllEmployees({ commit, state }) {
      return getAllEmployeesRequest(state.token, 50).then(response => {
        commit("setEmployees", response.data);
      });
    },
    addEmployee({ commit, state }, payload) {
      let data = {
        name: payload.name,
        email: payload.email
      };
      return addEmployeeRequest(state.token, data).then(response => {
        commit("addEmployee", response.data);
      });
    },
    updateEmployee({ commit, state }, payload) {
      let data = {
        employeeID: state.employees.find(emp => emp.email === payload.prevEmail)._id,
        name: payload.updates.name,
        email: payload.updates.email
      };
      return updateEmployeeRequest(state.token, data).then(response => {
        commit("updateEmployee", response.data);
      });
    },
    deleteEmployee({ commit, state }, payload) {
      let data = {
        employeeID: state.employees.find(emp => emp.email === payload.email)._id
      };
      return deleteEmployeeRequest(state.token, data).then(() => {
        commit("deleteEmployee", data);
      });
    },
    addEmployeeToCustomerNotifyOnOrder({ commit, state }, payload) {
      let data = { employeeID: payload.employeeID, dealerNumber: payload.dealerNumber };
      postEmployeeToNotifyOnOrderRequest(state.token, data);
    }
  },
  getters: {
    orderInState: state => orderno => {
      let result = state.orders.find(order => order.order_number === orderno);
      return result;
    },
    customer: state => dealerno => {
      return state.customers.find(c => c.dealer_number === dealerno);
    },
    employee: state => email => {
      return state.employees.find(c => c.email === email);
    }
  }
});

export default store;
